<template>
  <Summary
      :heading="setting.header"
      heading-icon="cipLogin"
      :palette="setting.palette"
      :tooltip="setting.tooltip"
      :heading-value="heading"
      :rows="rows"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Filters from "@/domain/core/utils/filters";
import {Settings} from "@/domain/stats/settings";
import Summary from "@/domain/stats/components/Summary.vue";
import MessageManager from "@/domain/core/utils/messageManager";
import mqttTopics from "@/domain/core/constant/mqttTopics";

export default {
  name: "CheckinsSummary",
  components: {Summary},
  async mounted() {
    await this.fetchSummaryCheckins()

    if (this.picaServiceId) {
      MessageManager.setParams({picaServiceId: this.picaServiceId})
      MessageManager.on(mqttTopics.stats.checkin, async (data) => {
        const metrics = { ...data.metrics }

        if (metrics.checkin_total !== undefined) metrics.total = metrics.checkin_total
        if (metrics.checkin_direct !== undefined)  metrics.direct = metrics.checkin_direct
        if (metrics.checkin_qrcode !== undefined) metrics.qrcode = metrics.checkin_qrcode

        await this.updateCheckinsSummary(metrics)
      }, 'checkinsSummary')
    }
  },

  beforeDestroy() {
    MessageManager.off('checkinsSummary')
  },
  computed: {
    ...mapGetters('nStats', [
      'checkinsSummary',
      'picaServiceId'
    ]),
    setting() {
      return Settings.summary.checkins
    },
    heading() {
      if (!this.checkinsSummary) return
      return Filters.number(this.checkinsSummary.total)
    },
    rows() {
      if (this.checkinsSummary === null)
        return []
      return [
        {
          title: this.setting.qrcode.title,
          tooltip: this.setting.qrcode.tooltip,
          value: Filters.number(this.checkinsSummary.qrcode)
        },
        {
          title: this.setting.direct.title,
          tooltip: this.setting.direct.tooltip,
          value: Filters.number(this.checkinsSummary.direct)
        }
      ]
    },
  },
  methods: {
    ...mapActions('nStats', [
      'fetchSummaryCheckins',
      'updateCheckinsSummary'
    ]),
  }
}
</script>
